import { lazy } from 'react';

export const CurrentCoinStats = lazy(() => import('./CurrentCoinStats.component'));
